import { render, staticRenderFns } from "./DesignObjectionToUsForm.vue?vue&type=template&id=8bc3b876&"
import script from "./DesignObjectionToUsForm.vue?vue&type=script&lang=js&"
export * from "./DesignObjectionToUsForm.vue?vue&type=script&lang=js&"
import style0 from "./DesignObjectionToUsForm.vue?vue&type=style&index=0&id=8bc3b876&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports